import service from '@/base/service'
import qs from 'qs'

const baseURL = process.env.VUE_APP_BASE_API_AI

const request = (data) => {
  return service({ ...data, ...{ baseURL } })
}
// 订阅管理
export function subscribeManagement(data) {
  return request({
    url: '/subscription/list',
    method: 'GET',
    params: data
  })
}

// 启用删除订阅
export function subscribeStatus(data) {
  return request({
    url: '/subscription/status',
    method: 'post',
    data
  })
}

// 校验名称
export function checkName(data) {
  return request({
    url: '/subscription/name/check',
    method: 'post',
    data
  })
}

// 新增商机订阅
export function addSubscribe(data) {
  return request({
    url: '/subscription/add',
    method: 'post',
    data
  })
}

// 高级搜索商机订阅企业列表
export function subscribeList(data) {
  return request({
    url: '/subscription/subscription',
    method: 'post',
    data
  })
}

// 高级搜索商机订阅企业列表总数 批量
export function subscribeListBatch(data) {
  return request({
    url: '/subscription/num',
    method: 'post',
    data
  })
}

// 商机订阅详情
export function subscribeDetail(data) {
  return request({
    url: `/subscription/${data.id}`,
    method: 'GET',
    params: {}
  })
}

// 修改商机订阅
export function editSubscribe(data) {
  return request({
    url: '/subscription/update',
    method: 'post',
    data
  })
}

// 点击商机订阅角标
export function clickMark(data) {
  return request({
    url: '/subscription/click',
    method: 'post',
    data
  })
}

// 小T查询当天推送的所有消息
export function subscribemessages(data) {
  return request({
    url: '/subscribemsg/messages',
    method: 'GET',
    params: data
  })
}

// 小T小红点查询当前是否有未读消息数量
export function subscribeUnreadCount(data) {
  return request({
    url: '/subscribemsg/unreadCount',
    method: 'GET',
    params: data
  })
}

// 轮询当前还未推送的消息
export function subscribePushmsg(data) {
  return request({
    url: '/subscribemsg/pushmsg',
    method: 'GET',
    params: data
  })
}

//更新消息已读，点击消息弹框触发
export function updateReadStatus(data) {
  return request({
    url: '/subscribemsg/updateReadStatus',
    method: 'post',
    data
  })
}